//////////////////////////////////////////////////////////////////////
//
//  09/26/18
//  src/containers/Navbar.js
//
//  This file is the top level Navbar for the project.
//

import React, { Component } from "react";
import { Link     } from "react-router-dom";
import { connect  } from "react-redux";
import { setCkBox } from "../store/actions/navbar";
import LinkRow     from "../components/LinkRow";
import RChecked    from "../images/RadCkBlue.png";
import RUnChecked  from "../images/RadUnCkBlue.png";
import './Navbar.css';

//
//  Top of the page 'Navbar'.
//
class Navbar extends Component {
  updateCkBox = ev => {
    ev.preventDefault();

    // Sometimes when starting the app this function is called with 
    // nothing in the 'outerText'.
    if( ev.target.outerText !== undefined ) {
      var str = ev.target.outerText.trim().toLowerCase();
      if( str !== "" ) {
        console.log( "Update Found: " + str );
        this.props.dispatch( setCkBox( str ) );
      }
    }
  }
  changeCkBox = ev => {
    var str_arr = ev.target.alt.split( " " );
    var str = str_arr[ 0 ].trim().toLowerCase();
    if( str !== "" ) {
      console.log( "Change Found: " + str );
      this.props.dispatch( setCkBox( str ) );
    }
  }
  render() {
    const { ckBox, topSt } = this.props.navbar;

    console.log( "Navbar - render: " );
    console.log( "Props ckBox: " + ckBox + ", topSt: " + topSt );
    var pullLinkRow = ( topSt === "page" );
    var pullCkBoxes = ( topSt === "city" || topSt ===  "page" );

    return (
      <nav className="nav_container">

        <div id="nav_city">
          <Link to={ `${ process.env.PUBLIC_URL }/` }>
          <svg 
            version="1.1" 
            baseProfile="full"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0, 0, 700, 610">

            <path strokeWidth="10px" stroke="black" strokeLinecap="square" fill="none"
              d="M  50 360 L  50  50 L 120  50 L 120 360" />

            <path strokeWidth="10px" stroke="black" strokeLinecap="square" fill="none"
              d="M 150 360 L 150 120 L 250 120 L 250 360" />

            <path strokeWidth="10px" stroke="black" strokeLinecap="square" fill="none"
              d="M 200 120 L200 70 L 270 10 L 340 70 L 340 360 M 200 70 L 340 70" />

            <path strokeWidth="10px" stroke="black" strokeLinecap="square" fill="none"
              d="M 370 360 L 370  30 L 510  30 L 510 360" />

            <path strokeWidth="10px" stroke="black" strokeLinecap="square" fill="none"
              d="M 550 360 L 550 100 L 630 100 L 630 360" />

            <path strokeWidth="10px" stroke="black" strokeLinecap="square" fill="none"
              d="M 20 565 L 700 565" />
          </svg>

          <div id="svg_text"><div id="svg_the">The</div><div id="svg_city">City Biz</div></div>
          <div id="svg_slogan">Find out what's happening in your city!</div>
          </Link>
        </div>

        { pullCkBoxes && (
          <div id="nav_box" onClick={ this.updateCkBox }>
            <Link to={ `${ process.env.PUBLIC_URL }/map` }>
                                <img className="NCBox" 
                                onClick={ this.changeCkBox } 
                                src={ ckBox === "map" ? RChecked : RUnChecked }
                                alt="Map Selection" />Map</Link>

            <Link to={ `${ process.env.PUBLIC_URL }/full` }>
                                <img className="NCBox"
                                onMouseOver = { this.test }
                                onClick={ this.changeCkBox } 
                                src={ ckBox === "full"     ? RChecked : RUnChecked }
                                alt="Full Selection"/>Full</Link>

            <Link to={ `${ process.env.PUBLIC_URL }/compact` }>
                                <img className="NCBox"
                                onMouseOver = { this.test }
                                onClick={ this.changeCkBox } 
                                src={ ckBox === "compact" ? RChecked : RUnChecked } 
                                alt="Compact Selection"/>Compact</Link>
          </div>
        )}
        
        <div id="nav_login">
          <Link to={ `${ process.env.PUBLIC_URL }/login` }>Login</Link>
        </div>	
        { pullLinkRow && (
          <div id="nav_link">
            <LinkRow { ...this.props }/>
          </div>
        )}
      </nav>
    );
  }
}

//
//  What 'mapStateToProps' does is take our 'state' data and make it 
//  so we can access all that 'state' data from our 'this.props' variable.
//
function mapStateToProps( state ) {
  console.log( "Navbar State to Props, ckBox: " + state.navbar.ckBox + ", topSt: " + state.navbar.topSt );
  return {
    navbar : state.navbar
  };
}

//
// How to tie 'mapStateToProps' to the 'Navbar' class.
//
export default connect( mapStateToProps, null )( Navbar );



// WEBPACK FOOTER //
// ./src/containers/Navbar.js